// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '파비스제약',
  targetSheetName: '라이징팜 제품 단가표(26.05.29)',
  headerRowIndex: 3,
  headerRowCount: 1,
  dataStartRowIndex: 4,
  repeatedHeaderRowAction: 'skip',
  columnMapping: {
    drugCode: '청구코드',
    drugName: '제품명',
    pharmaceuticalCompanyName: '허가제조사',
    price: '기준가',
    commissionRate: '수수료',
    commissionNote: '비고',
  },
  requiredHeaders: [
    '분류',
    '성분 함량',
    '자사생산여부',
    '생동여부',
    '제품명',
    '청구코드',
    '오리지널약',
    '구분',
    '기준가',
    '수수료',
    '허가제조사',
    '정산유무',
    '비고',
  ],
});
